export const accountSpec = [
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Account',
    name: 'account',
    type: 'text',
  },
]